import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import React, { useEffect, useMemo, useState } from "react";
import Table, { offerStatusFormatter } from "../tables/table";

function getData(offerHeaders, offerStatus) {
  return (offerHeaders || []).map((offerHeader) => ({
    id: `${offerHeader?.id}-${offerHeader?.revision_num}`,
    numOferta: offerHeader?.num_oferta,
    revisionNum: offerHeader?.revision_num,
    estado: offerStatus?.find((x) => x.id === offerHeader?.estado_id),
    obj: offerHeader,
  }));
}

const DuplicarOfertaRevisionDialog = (props) => {
  const { title, open, setOpen, data, offerStatus, onConfirm } = props;

  const [selectedRevision, setSelectedRevision] = useState(null);

  useEffect(() => {
    if (!open) {
      setSelectedRevision(null);
    }
  }, [open]);

  const tableData = useMemo(() => getData(data, offerStatus), [data, offerStatus]);

  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    bgColor: "#eef7ff",
    selected: selectedRevision
      ? [`${selectedRevision.id}-${selectedRevision.revision_num}`]
      : [],
    onSelect: (row) => {
      setSelectedRevision(row.obj);
    },
  };

  const columns = [
    { dataField: "numOferta", text: "Número de oferta", sort: true },
    {
      dataField: "revisionNum",
      text: "Revisión",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "estado",
      text: "Estado",
      sort: true,
      headerAlign: "center",
      align: "center",
      formatter: offerStatusFormatter,
    },
  ];

  return (
    <Dialog
      fullWidth={true}
      maxWidth="lg"
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="duplicar-oferta-revision-dialog"
      className="backdrop"
    >
      <DialogTitle id="duplicar-oferta-revision-dialog">{title}</DialogTitle>
      <DialogContent>
        {!tableData.length ? (
          <p>{"No hay revisiones disponibles."}</p>
        ) : (
          <Table data={tableData} columns={columns} selectRow={selectRow} />
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
            setSelectedRevision(null);
          }}
          variant="outlined"
        >
          Cancelar
        </Button>
        <Button
          onClick={() => {
            if (!selectedRevision) return;
            onConfirm(selectedRevision);
            setOpen(false);
            setSelectedRevision(null);
          }}
          variant="outlined"
          color="primary"
          disabled={!selectedRevision}
        >
          Duplicar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicarOfertaRevisionDialog;
